import { FileText, Receipt as ReceiptIcon } from "lucide-react";
import type { Receipt, Category } from "../../types";
import { CategoryBadge } from "../categories/CategoryBadge";

interface Props {
  receipt: Receipt;
  categories: Category[];
  onClick: () => void;
}

export function ReceiptItem({ receipt, categories, onClick }: Props) {
  const category = categories.find(c => c.id === receipt.category_id) ?? null;
  const amount = receipt.amount ? `£${parseFloat(receipt.amount).toFixed(2)}` : "—";
  const dateStr = receipt.receipt_date
    ? new Date(receipt.receipt_date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
    : "No date";

  return (
    <div onClick={onClick} style={{
      display: "flex", alignItems: "center", gap: "1rem",
      padding: "0.75rem 1rem", borderBottom: "1px solid #1e293b",
      cursor: "pointer", transition: "background 0.15s",
    }}
    onMouseEnter={e => (e.currentTarget.style.background = "#1e293b")}
    onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
    >
      <div style={{ width: "40px", height: "40px", background: "#1e293b", borderRadius: "6px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b" }}>
        {receipt.file_type === "pdf" ? <FileText size={20} /> : <ReceiptIcon size={20} />}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: "#f1f5f9", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {receipt.merchant || "Unknown merchant"}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "0.25rem" }}>
          <span style={{ color: "#64748b", fontSize: "0.8rem" }}>{dateStr}</span>
          <CategoryBadge category={category} />
        </div>
      </div>
      <div style={{ color: "#4ade80", fontWeight: 600, fontSize: "1rem", flexShrink: 0 }}>{amount}</div>
    </div>
  );
}
